"use strict";
import React from "react";
import PropTypes from "prop-types";

const WorkflowRoot = (props) => {
    props.setStepCount(React.Children.count(props.children));
    let children = React.Children.map(props.children, (child, index) => {
        let showCurrentStep = index <= props.activeStepIndex();
        if(props.onlyShowCurrentStep) {
            showCurrentStep = index === props.activeStepIndex();
        }
        return showCurrentStep && React.cloneElement(child, {
                isFirstStep: () => props.isFirstStep(),
                isLastStep: () => props.isLastStep(),
                setValue: props.setValue.bind(props, index),
                setStepComplete: () => {
                    let canProceed = true;
                    if(child.props && typeof(child.props.setStepComplete) === 'function') {
                        canProceed = child.props.setStepComplete(props.values(), index) !== false;
                    }
                    if(canProceed) {
                        props.setStepComplete(index)
                    }
                },
                setStepPrevious: () => props.setStepPrevious(),
                setWorkflowComplete: () => props.setWorkflowComplete(index),
                setValidity: (key, value) => props.setValidity(key, value),
                validity: props.validity(),
                values: props.values(),
                errorMessages: props.errorMessages(),
                index: index,
                activeStepIndex: props.activeStepIndex()
            });
    });


    return (
        <div>
            {children}
        </div>
    );
};

WorkflowRoot.propTypes = {
    activeStepIndex: PropTypes.func.isRequired,
    errorMessages: PropTypes.func.isRequired,
    isFirstStep: PropTypes.func.isRequired,
    isLastStep: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    setStepComplete: PropTypes.func.isRequired,
    setStepPrevious: PropTypes.func.isRequired,
    setWorkflowComplete: PropTypes.func.isRequired,
    setStepCount: PropTypes.func.isRequired,
    setValidity: PropTypes.func.isRequired,
    validity: PropTypes.func.isRequired,
    onlyShowCurrentStep: PropTypes.bool
};

WorkflowRoot.defaultProps = {
    onlyShowCurrentStep: false
};

module.exports = WorkflowRoot;